import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component,
    EventEmitter,
    Output,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    OnDestroy,
    OnInit, inject, DestroyRef } from '@angular/core';
  import { forkJoin, Observable, Subscription } from 'rxjs';
  import * as _ from 'lodash-es';
  import { Form8858TextualinfoService } from './form-8858-textualinfo.service';
  import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
  import { NumberWithCommasPipe } from '../../../shared/pipes/number-with-commas.pipe';
  import { GlobalService } from '../../../global/services/global.service';
  import { WorkspaceService } from '../../../workspace/workspace.service';
  import { AppService } from '../../../app.service';
  import {
    extractObject,
    generalConfigFromGlobal,
    hydratedGlobalParams,
    normalizeFilterParams,
    rowPayloadFromActiveScreen
  } from '../../../shared/workspace-element-context';

  @Component({
    selector: 'gtw-form-8858-textualinfo',
    templateUrl: './form-8858-textualinfo.component.html',
    styleUrls: ['./form-8858-textualinfo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NumberWithCommasPipe],
    standalone: false
})
  export class Form8858TextualinfoComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

    @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();
  
    modalTitle = 'Form 8858- Information Return of U.S. Persons With Respect To Foreign Disregarded Entities';
    minimise = false;
    modal_name: string | null = null;
    crudLoading = false;
    showFormLoader = true;
    tabTitle = ['Schedule G Other Information', 'Schedule I Other Information'];
  
    rowData: any = {};
    filterParams: any = {};
    globalService: any = {};
    GENERAL_CONFIG: any = {};
    USER_SETTINGS: any = {};
    SERVER_CONFIG: any = {};
    tax_year = '';
  
    attribData: { [key: string]: any } = {};
    irsF8858ScheduleNAData: any[] = [];
    irsF8858ScheduleNADataTemp: any[] = [];
    line1Data: any[] = [];
    scheduleGData: any[] = [];
    scheduleIData: any[] = [];
    originalGData: any[] = [];
    originalIData: any[] = [];
  
    filingGroup: any[] = [];
    filingGroup1: any[] = [];
    countries: any[] = [];
    states: any[] = [];
    currencies: any[] = [];
    PrincipalBusinessActivity: any[] = [];
  
    selectedGroup: any = null;
    selectedGroup1: any = {};
    countryVar = '';
    countryCust = '';
    radioIn = 'N';
    refrence_iddisabled = false;
    batch_flag_2a = false;
    batch_flag_2b = false;
    error_flag = false;
    saveFlag = false;
  
    enabledBRUSTaxType = false;
    enabledBRCFCTaxType = false;
    isSaveValidFlagG = true;
    isSaveValidFlagI = true;
    invalidSaveMessageG = '';
    invalidSaveMessageI = '';
  
    dateOptions = { dateDisabled: false, formatYear: 'yyyy', startingDay: 1, showWeeks: false };
    calendar = { opened: false };
    date: any = { startDate: false, endDate: false, disregardedDate: false };
  
    /** Date format for ap-date-picker: numeric day (01-31), month, year - e.g. 01/08/2024 */
    readonly datePickerFormat = 'DD/MM/yyyy';

    private isInitialized = false;
    private isLoading = false;
    private readonly subscriptions = new Subscription();

    constructor(
      private service: Form8858TextualinfoService,
      private gtwSnackbarService: GtwSnackbarService,
      private cdr: ChangeDetectorRef,
      private numberWithCommasPipe: NumberWithCommasPipe,
      private gtwGlobal: GlobalService,
      private gtwWorkspace: WorkspaceService,
      private gtwApp: AppService
    ) {}

    ngOnInit(): void {
      this.applyWorkspaceContext();
      this.resetAndInit();
      this.subscriptions.add(
        this.gtwWorkspace.setTabActive.subscribe(() => {
          this.applyWorkspaceContext();
          this.resetAndInit();
        })
      );
      this.subscriptions.add(
        this.gtwGlobal.globalParamsChanged$.subscribe(() => {
          this.applyWorkspaceContext();
          this.resetAndInit();
        })
      );
    }

    ngOnDestroy(): void {
      this.subscriptions.unsubscribe();
    }

    private applyWorkspaceContext(): void {
      const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
      const fp = normalizeFilterParams(activeScreen);
      this.filterParams = fp;
      const gc = generalConfigFromGlobal(this.gtwGlobal);
      this.GENERAL_CONFIG = { ...gc, base_url: gc.base_url ?? gc.api ?? '' };
      const hydrated = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
      this.globalService = {
        ...extractObject(this.gtwGlobal.global?.globalParams || {}),
        ...extractObject(hydrated)
      };
      this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
      this.SERVER_CONFIG = this.gtwApp.SERVER_CONFIG || {};
      const rawRow = rowPayloadFromActiveScreen(activeScreen);
      const rowObj = Array.isArray(rawRow)
        ? extractObject(rawRow[0]?.data ?? rawRow[0])
        : extractObject(rawRow);
      if (Object.keys(rowObj).length) {
        this.rowData = rowObj;
      }
    }

    private resetAndInit(): void {
      this.isInitialized = false;
      this.isLoading = false;
      this.init();
    }
  
    private getTaxYear(): string {
      return this.filterParams?.tax_year || this.globalService?.tax_year || this.rowData?.TAX_YEAR || '';
    }
  
    private getScenario(): string {
      return this.filterParams?.scenario || this.globalService?.scenario || '';
    }
  
    private getJcdKey(): string | number {
      const j = this.filterParams?.jcd_key ?? this.globalService?.jcd_key ?? this.rowData?.JCD_KEY;
      return (j === '' || j === undefined) ? 250 : j;
    }
  
    /**
     * Build an enriched copy of globalService that guarantees scenarioCode,
     * is_issue_key_enabled and checkLockedbj are present.
     *
     * In AngularJS these live on GlobalService.globalParams at save-time
     * (set by gridController). The Angular 12 snapshot may miss them if
     * the grid controller hadn't finished when headerData was copied,
     * so we add fallbacks matching the pattern from sourcing-input-app-basket
     * and non-financial-information.
     */
    private buildSaveGlobalService(): any {
      const gs = { ...(this.globalService || {}) };
      const fp = this.filterParams || {};
      const rd = this.rowData || {};
  
      if (!gs.scenarioCode) {
        gs.scenarioCode = fp.scenarioCode || fp.scenario_code || 'RAF';
      }
      if (!gs.is_issue_key_enabled) {
        gs.is_issue_key_enabled = fp.is_issue_key_enabled || 'N';
      }
  
      if (!gs.checkLockedbj) {
        const scenario = fp.scenario || gs.scenario || rd.SCENARIO;
        const checkLocked = [{
          leid: rd.LEID || '',
          cdr_number: rd.CDR_NO || rd.MARS || '',
          consol_group_key: String(rd.CONSOL_GROUP_KEY || ''),
          reporting_period: String(rd.REPORTING_PERIOD || 1),
          combination_key: String(rd.COMBINATION_KEY || ''),
          scenario_key: parseInt(scenario, 10) || 0
        }];
        gs.checkLockedbj = JSON.stringify(checkLocked);
      }
  
      return gs;
    }
  
    /**
     * Converts a date string from backend format to YYYY-MM-DD format for HTML5 date input.
     * Uses local date only so 01/01/2024 is not shifted to 12/31/2023 in US timezones.
     */
    private formatDateForInput(dateStr: string | null): string | null {
      if (!dateStr) return null;
      const s = String(dateStr).trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
      const d = new Date(s);
      if (isNaN(d.getTime())) return null;
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    }
  
    init() {
      if (this.isInitialized || this.isLoading) {
        return;
      }
      if (!this.GENERAL_CONFIG?.base_url || !this.rowData || Object.keys(this.rowData).length === 0) {
        return;
      }
      this.isLoading = true;
      this.isInitialized = true;
      this.modal_name = 'form-8858-textualinfo';
      this.tax_year = this.getTaxYear();
      this.showFormLoader = true;
      this.cdr.detectChanges();

      const baseUrl = this.GENERAL_CONFIG.base_url;
      const params = _.merge({}, this.globalService || {}, this.filterParams || {});
      params.action_code = 'f5sne6';
  
      this.loadLookups();
      this.service.loadJsonObject(baseUrl, params, this.globalService).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (data: any) => {
          this.isLoading = false;
          if (data?.callSuccess === '1' && data?.jsonObject) {
            this.filingGroup = data.jsonObject;
            this.filingGroup1 = data.jsonObject;
            this.getFormData();
            this.get8858Line1Data();
            this.loadscheduleIData();
          }
          this.cdr.detectChanges();
        },
        (err) => {
          console.error('Load filing group error', err);
          this.isLoading = false;
          this.showFormLoader = false;
          this.cdr.detectChanges();
        }
      );
    }
  
    private getFormData() {
      const fp = this.filterParams || {};
      const gs = this.globalService?.globalParams ?? this.globalService ?? {};
      const rd = this.rowData || {};
      const params: any = {
        action_code: 'mpx16c',
        activity_key: fp.activity_key ?? gs.activity_key ?? '',
        combination_key: rd.COMBINATION_KEY ?? '',
        filing_key: fp.filing_key ?? rd.CONSOL_GROUP_KEY ?? gs.filing_key ?? '1',
        irs_form_no: 'F8858',
        is_issue_key_enabled: fp.is_issue_key_enabled ?? gs.is_issue_key_enabled ?? 'N',
        is_locked: fp.is_locked ?? gs.is_locked ?? 'N',
        issue_id: fp.issue_id ?? gs.issue_id ?? '',
        issue_id_for_tx_save: fp.issue_id_for_tx_save ?? gs.issue_id_for_tx_save ?? '',
        issue_short_desc: fp.issue_short_desc ?? gs.issue_short_desc ?? '',
        jcd_key: this.getJcdKey(),
        jcd_ta_key: fp.jcd_ta_key ?? gs.jcd_ta_key ?? '',
        parent_me_string: fp.parent_me_string ?? rd.PARENT_ME_STRING ?? '',
        scenario: this.getScenario(),
        scenarioCode: fp.scenarioCode ?? gs.scenarioCode ?? 'RAF',
        screen_key: fp.screen_key ?? gs.screen_key ?? '',
        screen_type: fp.screen_type ?? gs.screen_type ?? 'grid',
        tax_year: this.getTaxYear()
      };
      this.service.loadJsonObject(this.GENERAL_CONFIG.base_url, params, this.globalService).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (data: any) => {
          if (data?.callSuccess === '1' && data?.jsonObject) {
            this.irsF8858ScheduleNAData = data.jsonObject;
            this.irsF8858ScheduleNADataTemp = data.jsonObject;
            this.processFormData();
            this.loadscheduleGData();
          }
          this.cdr.detectChanges();
        },
        (err) => {
          console.error('Load form data error', err);
          this.cdr.detectChanges();
        }
      );
    }
  
    private get8858Line1Data() {
      const fp = this.filterParams || {};
      const gs = this.globalService?.globalParams ?? this.globalService ?? {};
      const rd = this.rowData || {};
      const params: any = {
        action_code: '6tbecb',
        activity_key: fp.activity_key ?? gs.activity_key ?? '',
        combination_key: rd.HO_COMBINATION_KEY ?? rd.COMBINATION_KEY ?? '',
        filing_key: fp.filing_key ?? rd.CONSOL_GROUP_KEY ?? gs.filing_key ?? '1',
        ho_cdr_no: rd.CDR_NO ?? rd.HO_CDR_NO ?? '',
        ho_leid: rd.LEID ?? rd.HO_LEID ?? '',
        ho_rpt_pd: rd.REPORTING_PERIOD ?? rd.HO_REPORTING_PERIOD ?? 1,
        is_issue_key_enabled: fp.is_issue_key_enabled ?? gs.is_issue_key_enabled ?? 'N',
        is_locked: fp.is_locked ?? gs.is_locked ?? 'N',
        issue_id: fp.issue_id ?? gs.issue_id ?? '',
        issue_id_for_tx_save: fp.issue_id_for_tx_save ?? gs.issue_id_for_tx_save ?? '',
        issue_short_desc: fp.issue_short_desc ?? gs.issue_short_desc ?? '',
        jcd_key: this.getJcdKey(),
        jcd_ta_key: fp.jcd_ta_key ?? gs.jcd_ta_key ?? '',
        parent_me_string: fp.parent_me_string ?? rd.PARENT_ME_STRING ?? '',
        scenario: this.getScenario(),
        scenarioCode: fp.scenarioCode ?? gs.scenarioCode ?? 'RAF',
        screen_key: fp.screen_key ?? gs.screen_key ?? '',
        screen_type: fp.screen_type ?? gs.screen_type ?? 'grid',
        tax_year: this.getTaxYear()
      };
      this.service.loadJsonObject(this.GENERAL_CONFIG.base_url, params, this.globalService).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (data: any) => {
          if (data?.callSuccess === '1' && data?.jsonObject) {
            this.line1Data = data.jsonObject;
          }
          this.cdr.detectChanges();
        }
      );
    }
  
    private processFormData() {
      const arr = this.irsF8858ScheduleNAData;
      if (!arr || arr.length < 1) return;
      for (let i = 0; i < arr.length; i++) {
        const tempValue = arr[i].attrib_value || '';
        const attribName = tempValue.split('~')[0];
        let attribValue = (arr[i].VALUE === '0' ? '' : arr[i].VALUE);
        const updateFlag = arr[i].OVERRIDE_FLAG;
        const tempString = arr[i].object_id || '';
        const line_no_new = arr[i].line_no;
  
        if (arr[i].BATCH_FLAG === 'Y' && arr[i].line_no === '2A') this.batch_flag_2a = true;
        if (arr[i].BATCH_FLAG === 'Y' && arr[i].line_no === '2B') this.batch_flag_2b = true;
  
        (this.irsF8858ScheduleNAData as any)[i] = {
          i: arr[i],
          tax_year: tempString.split('~')[0],
          trans_type_key: tempString.split('~')[1],
          attrib_name: attribName,
          line_attrib_key: tempValue.split('~')[1],
          trans_details_key: tempString.split('~')[3],
          occurrence: tempString.split('~')[4],
          VALUE: arr[i].VALUE,
          form_key: tempString.split('~')[6],
          is_update: updateFlag,
          line_no: line_no_new
        };
  
        if (attribName === '8858_NA_FDE_BEGIN_DATE') {
          this.attribData['8858_NA_FDE_BEGIN_DATE'] = this.formatDateForInput(attribValue as string);
        } else if (attribName === '8858_NA_FDE_END_DATE') {
          this.attribData['8858_NA_FDE_END_DATE'] = this.formatDateForInput(attribValue as string);
        } else if (attribName === '8858_NA_ENTITY_ORGANIZATION_DATE') {
          this.attribData['8858_NA_ENTITY_ORGANIZATION_DATE'] = this.formatDateForInput(attribValue as string);
        } else if (attribName === '8858_NA_FDE_EFFECTIVE_DATE') {
          this.attribData['8858_NA_FDE_EFFECTIVE_DATE'] = this.formatDateForInput(attribValue as string);
        } else if (attribName === '8858_NA_FDE_FB_US_COUNTRY' && attribValue === 'US') {
          this.countryVar = 'US';
          this.attribData['8858_NA_FDE_FB_US_COUNTRY'] = 'US';
          this.attribData['8858_NA_FDE_FB_F_COUNTRY'] = null;
          ['8858_NA_FDE_FB_F_ADDR_1', '8858_NA_FDE_FB_F_ADDR_2', '8858_NA_FDE_FB_F_CITY', '8858_NA_FDE_FB_F_STATE', '8858_NA_FDE_FB_F_ZIP'].forEach(k => this.attribData[k] = null);
        } else if (attribName === '8858_NA_FDE_FB_F_COUNTRY' && attribValue !== 'US') {
          this.countryVar = attribValue as string;
          this.attribData['8858_NA_FDE_FB_F_COUNTRY'] = attribValue;
          this.attribData['8858_NA_FDE_FB_US_COUNTRY'] = null;
          ['8858_NA_FDE_FB_US_ADDR_1', '8858_NA_FDE_FB_US_ADDR_2', '8858_NA_FDE_FB_US_CITY', '8858_NA_FDE_FB_US_STATE', '8858_NA_FDE_FB_US_ZIP'].forEach(k => this.attribData[k] = null);
        } else if (attribName === '8858_NA_PERSONS_BOOK_US_COUNTRY' && attribValue === 'US') {
          this.countryCust = 'US';
          this.attribData['8858_NA_PERSONS_BOOK_US_COUNTRY'] = 'US';
          this.attribData['8858_NA_PERSONS_BOOK_F_COUNTRY'] = null;
          ['8858_NA_PERSONS_BOOK_F_ADDR_1', '8858_NA_PERSONS_BOOK_F_ADDR_2', '8858_NA_PERSONS_BOOK_F_CITY', '8858_NA_PERSONS_BOOK_F_STATE', '8858_NA_PERSONS_BOOK_F_ZIP'].forEach(k => this.attribData[k] = null);
        } else if (attribName === '8858_NA_PERSONS_BOOK_F_COUNTRY' && attribValue !== 'US') {
          this.countryCust = attribValue as string;
          this.attribData['8858_NA_PERSONS_BOOK_F_COUNTRY'] = attribValue;
          this.attribData['8858_NA_PERSONS_BOOK_US_COUNTRY'] = null;
          ['8858_NA_PERSONS_BOOK_US_ADDR_1', '8858_NA_PERSONS_BOOK_US_ADDR_2', '8858_NA_PERSONS_BOOK_US_CITY', '8858_NA_PERSONS_BOOK_US_STATE', '8858_NA_PERSONS_BOOK_US_ZIP'].forEach(k => this.attribData[k] = null);
        } else if (attribName === '8858_NA_FILER_LEGAL_ENTITY_ID') {
          const fg = this.filingGroup.find((f: any) => String(f.LEGAL_ENTITY_ID) === String(attribValue));
          if (fg) this.selectedGroup = fg;
        } else if (attribName === '8858_NA_FILER_BEGIN_DATE') {
          this.attribData['8858_NA_FILER_BEGIN_DATE'] = this.formatDateForInput(attribValue as string);
        } else if (attribName === '8858_NA_FILER_END_DATE') {
          this.attribData['8858_NA_FILER_END_DATE'] = this.formatDateForInput(attribValue as string);
        } else if (attribName === '8858_NA_INIT_FORM_Y' && attribValue === '1') {
          this.radioIn = 'I';
          this.attribData['8858_NA_INIT_FORM_Y'] = attribValue;
        } else if (attribName === '8858_NA_FINAL_FORM_Y' && attribValue === '1') {
          this.radioIn = 'F';
          this.attribData['8858_NA_FINAL_FORM_Y'] = attribValue;
        } else if (attribName === '8858_NA_FDE_FB_EIN' && (attribValue === undefined || attribValue === '')) {
          this.refrence_iddisabled = true;
        } else {
          this.attribData[attribName] = attribValue;
        }
      }
    }
  
    private loadscheduleGData() {
      const fp = this.filterParams || {};
      const gs = this.globalService?.globalParams ?? this.globalService ?? {};
      const rd = this.rowData || {};
      const params: any = {
        action_code: '3527y2',
        activity_key: fp.activity_key ?? gs.activity_key ?? '',
        combination_key: rd.COMBINATION_KEY ?? '',
        filing_key: fp.filing_key ?? rd.CONSOL_GROUP_KEY ?? gs.filing_key ?? '1',
        irs_form_no: 'F8858',
        is_issue_key_enabled: fp.is_issue_key_enabled ?? gs.is_issue_key_enabled ?? 'N',
        is_locked: fp.is_locked ?? gs.is_locked ?? 'N',
        issue_id: fp.issue_id ?? gs.issue_id ?? '',
        issue_id_for_tx_save: fp.issue_id_for_tx_save ?? gs.issue_id_for_tx_save ?? '',
        issue_short_desc: fp.issue_short_desc ?? gs.issue_short_desc ?? '',
        jcd_key: this.getJcdKey(),
        jcd_ta_key: fp.jcd_ta_key ?? gs.jcd_ta_key ?? '',
        parent_me_string: fp.parent_me_string ?? rd.PARENT_ME_STRING ?? '',
        scenario: this.getScenario(),
        scenarioCode: fp.scenarioCode ?? gs.scenarioCode ?? 'RAF',
        screen_key: fp.screen_key ?? gs.screen_key ?? '',
        screen_type: fp.screen_type ?? gs.screen_type ?? 'grid',
        tax_year: this.getTaxYear()
      };
      this.service.loadJsonObject(this.GENERAL_CONFIG.base_url, params, this.globalService).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (data: any) => {
          if (data?.callSuccess === '1' && data?.jsonObject) {
            const scheduleGData = data.jsonObject;
            this.scheduleGData = this.processScheduleGOrI(scheduleGData);
            
            // Run validation on each row during initialization (matching AngularJS ng-init behavior)
            for (let i = 0; i < this.scheduleGData.length; i++) {
              this.checkingForValidation(this.scheduleGData[i], i);
            }
            
            this.enabledBRUSTaxType = (this.rowData.TAX_TYPE === 'BRUS' || this.rowData.TAX_TYPE === 'BRPTP');
            this.enabledBRCFCTaxType = (this.rowData.TAX_TYPE === 'BRCFC' || this.rowData.TAX_TYPE === 'BRUS' || this.rowData.TAX_TYPE === 'BRPTP');
            if (!this.enabledBRUSTaxType && this.scheduleGData.length > 12) {
              for (let k = 13; k <= 24 && k < this.scheduleGData.length; k++) {
                this.scheduleGData[k].isEditableFlag = 'N';
                this.scheduleGData[k].isVisibleFlag = 'N';
              }
            }
            if (!this.enabledBRCFCTaxType && this.scheduleGData[12]) {
              this.scheduleGData[12].isEditableFlag = 'N';
              this.scheduleGData[12].isVisibleFlag = 'N';
            }
            this.originalGData = _.cloneDeep(this.scheduleGData);
            this.setAmt();
          }
          this.showFormLoader = false;
          this.cdr.detectChanges();
        },
        (err) => {
          console.error('Load schedule G error', err);
          this.showFormLoader = false;
          this.cdr.detectChanges();
        }
      );
    }
  
    private loadscheduleIData() {
      const params: any = {
        action_code: 'zkn7je',
        tax_year: this.getTaxYear(),
        scenario: this.getScenario(),
        jcd_key: this.getJcdKey(),
        irs_form_no: 'F8858',
        combination_key: this.rowData.COMBINATION_KEY
      };
      this.service.loadJsonObject(this.GENERAL_CONFIG.base_url, params, this.globalService).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (data: any) => {
          if (data?.callSuccess === '1' && data?.jsonObject) {
            const scheduleIData = data.jsonObject;
            this.scheduleIData = this.processScheduleGOrI(scheduleIData);
            
            // Run validation on each row during initialization (matching AngularJS behavior)
            for (let i = 0; i < this.scheduleIData.length; i++) {
              this.checkingForValidationForI(this.scheduleIData[i], i);
            }
            
            const enabled = (this.rowData.TAX_TYPE === 'BRCFC' || this.rowData.TAX_TYPE === 'BRUS' || this.rowData.TAX_TYPE === 'BRPTP');
            if (!enabled) {
              this.scheduleIData.forEach((row: any) => {
                row.isEditableFlag = 'N';
                row.isVisibleFlag = 'N';
              });
            }
            this.originalIData = _.cloneDeep(this.scheduleIData);
          }
          this.cdr.detectChanges();
        }
      );
    }
  
    private processScheduleGOrI(data: any[]): any[] {
      const out: any[] = [];
      if (!data || data.length < 2) return out;
      let i = 1;
      let previous_line_no = data[i]?.line_no;
      while (i < data.length) {
        let tempObj: any = {};
        let j = i;
        let count = 0;
        while (j < data.length && previous_line_no === data[j].line_no) {
          const av = (data[j].attrib_value || '').split('~');
          const key = av[0];
          if (key === 'LINE_NO') {
            tempObj.propertyType = data[j].PROPERTY_TYPE;
            tempObj.line_no = data[j].line_no;
            tempObj.parent_line_no = data[j].PARENT_LINE_NO;
            // Added missing fields from AngularJS (col_id, parent_col_id, line_type)
            tempObj.col_id = data[j].COL_ID;
            tempObj.parent_col_id = data[j].PARENT_COL_ID;
            tempObj.line_type = data[j].LINE_TYPE;
            tempObj.saveParams = {
              tax_year: (data[j].object_id || '').split('~')[0],
              trans_type_key: (data[j].object_id || '').split('~')[1],
              trans_Details_key: (data[j].object_id || '').split('~')[3],
              form_key: (data[j].object_id || '').split('~')[6],
              occurrence: (data[j].object_id || '').split('~')[4]
            };
          } else if (key === 'LINE_DESCRIPTION') {
            tempObj.line_description = av[3];
          } else {
            // Capture this attribute row's OWN trans_dtls_key / occurrence from its
            // object_id. The marker-row saveParams carry 0/0 (template), so re-saves
            // need the real per-attribute keys to UPDATE instead of mis-INSERTing.
            const oid = (data[j].object_id || '').split('~');
            if (count > 0) {
              if (count === 1) {
                tempObj.attrib_name = [tempObj.attrib_name];
                tempObj.value = [tempObj.value];
              }
              tempObj.attrib_name[count] = av[0];
              tempObj.value[count] = { VALUE: data[j].VALUE, line_attrib_key: av[1], trans_dtls_key: oid[3], occurrence: oid[4] };
            } else {
              tempObj.propertyType = data[j].PROPERTY_TYPE;
              tempObj.isEditableFlag = 'Y';
              tempObj.isVisibleFlag = 'Y';
              tempObj.isSaveValidFlagG = 'Y';
              tempObj.attrib_name = av[0];
              tempObj.value = { VALUE: data[j].VALUE, line_attrib_key: av[1], trans_dtls_key: oid[3], occurrence: oid[4] };
            }
          }
          previous_line_no = data[j].line_no;
          if (Number(data[j].PROPERTY_TYPE) === 13) count++;
          j++;
        }
        if (j < data.length) previous_line_no = data[j].line_no;
        out.push(tempObj);
        i = j;
      }
      return out;
    }
  
    private setAmt() {
      const params: any = {
        action_code: 'a0gmzp',
        tax_year: this.getTaxYear(),
        scenario: this.getScenario(),
        combination_key: this.rowData.COMBINATION_KEY,
        jcd_key: this.getJcdKey()
      };
      this.service.loadJsonObject(this.GENERAL_CONFIG.base_url, params, this.globalService).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (data: any) => {
          if (data?.callSuccess === '1' && data?.jsonObject?.[0]) {
            const obj = data.jsonObject[0];
            const temp_amt = obj.SEC_901M_AMT;
            const temp_amt1 = obj.SEC_909_SUSP_TAX;
            const temp_amt2 = obj.SEC_909_TAX_RELEASED;
            const auto1 = this.scheduleGData.filter((p: any) => (p.line_type || '').indexOf('auto1') !== -1);
            const auto2 = this.scheduleGData.filter((p: any) => (p.line_type || '').indexOf('auto2') !== -1);
            const auto3 = this.scheduleGData.filter((p: any) => (p.line_type || '').indexOf('auto3') !== -1);
            const value1 = auto1[0] ? this.scheduleGData.find((x: any) => x.attrib_name === auto1[0].attrib_name) : null;
            const value2 = auto2[0] ? this.scheduleGData.find((x: any) => x.attrib_name === auto2[0].attrib_name) : null;
            const value3 = auto3[0] ? this.scheduleGData.find((x: any) => x.attrib_name === auto3[0].attrib_name) : null;
            if (value1 && Array.isArray(value1.value)) {
              if (temp_amt != null && temp_amt !== 0) {
                value1.value[0].VALUE = 'Y';
                value1.value[1].VALUE = null;
              } else {
                if (value1.value[0].VALUE === 'Y') {
                  value1.value[0].VALUE = 'Y';
                  value1.value[1].VALUE = null;
                } else {
                  value1.value[1].VALUE = 'N';
                  value1.value[0].VALUE = null;
                }
              }
            }
            if (value2 && Array.isArray(value2.value)) {
              if (temp_amt1 != null && temp_amt2 != null && (temp_amt1 !== 0 || temp_amt2 !== 0)) {
                value2.value[0].VALUE = 'Y';
                value2.value[1].VALUE = null;
              } else {
                if (value2.value[0].VALUE === 'Y') {
                  value2.value[0].VALUE = 'Y';
                  value2.value[1].VALUE = null;
                } else {
                  value2.value[1].VALUE = 'N';
                  value2.value[0].VALUE = null;
                }
              }
            }
            if (value3 && Array.isArray(value3.value)) {
              if (value3.value[1]?.VALUE === undefined && value3.value[0]?.VALUE === undefined) {
                value3.value[0].VALUE = 'Y';
                value3.value[1].VALUE = null;
              } else if (value3.value[0].VALUE === 'Y') {
                value3.value[0].VALUE = 'Y';
                value3.value[1].VALUE = null;
              } else {
                value3.value[1].VALUE = 'N';
                value3.value[0].VALUE = null;
              }
            }
          }
          this.cdr.detectChanges();
        }
      );
    }
  
    private loadLookups() {
      const base = this.GENERAL_CONFIG.base_url;
      const jcd = this.getJcdKey();
      const tax_year = this.getTaxYear();
      const p: any = { tax_year, jcd_key: jcd };
      forkJoin({
        countries: this.service.loadJsonObject(base, { ...p, action_code: 'kbuwei' }, this.globalService),
        currencies: this.service.loadJsonObject(base, { ...p, action_code: '3ucwjb' }, this.globalService),
        states: this.service.loadJsonObject(base, { ...p, action_code: '6eyqnz' }, this.globalService),
        principal: this.service.loadJsonObject(base, { action_code: 'y5ypqx', ...p }, this.globalService)
      }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        (res: any) => {
          if (res.countries?.callSuccess === '1' && res.countries?.jsonObject) this.countries = res.countries.jsonObject;
          if (res.currencies?.callSuccess === '1' && res.currencies?.jsonObject) this.currencies = res.currencies.jsonObject;
          if (res.states?.callSuccess === '1' && res.states?.jsonObject) this.states = res.states.jsonObject;
          if (res.principal?.callSuccess === '1' && res.principal?.jsonObject) this.PrincipalBusinessActivity = res.principal.jsonObject;
          this.cdr.detectChanges();
          // With OnPush, <select> options rendered via *ngFor may not re-sync
          // the selected value when options arrive after the model value is set.
          // A deferred detectChanges forces Angular to re-evaluate after the
          // new <option> elements are in the DOM.
          setTimeout(() => this.cdr.detectChanges());
        }
      );
    }
  
    findIndex_text(data: any[], attribName: string, value: string) {
      const findData = data.find((x: any) => x.attrib_name === attribName);
      if (findData) findData.is_update = value;
      return findData;
    }
  
    getFilingGroup(filingID: string): any {
      return this.filingGroup.find((f: any) => String(f.LEGAL_ENTITY_ID) === String(filingID)) || null;
    }
  
    getPrincipalBusinessActivity(activityCode: string): any {
      return this.PrincipalBusinessActivity.find((a: any) => String(a.ACTIVITY_CODE) === String(activityCode)) || {};
    }
  
    getPrincipalBusinessActivity2(activityDesc: string): any {
      return this.PrincipalBusinessActivity.find((a: any) => a.ACTIVITY_DESC === activityDesc) || {};
    }
  
    updated(filingID: string) {
      if (this.irsF8858ScheduleNAData.length > 0) {
        const filing_group_db = this.irsF8858ScheduleNAData.find((x: any) => x.attrib_name === '8858_NA_FILER_LEGAL_ENTITY_ID');
        if (filing_group_db) {
          // Compare original VALUE against new filingID to set is_update flag (matching AngularJS behavior)
          (filing_group_db as any).VALUE == filingID
            ? this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FILER_LEGAL_ENTITY_ID', 'N')
            : this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FILER_LEGAL_ENTITY_ID', 'Y');
        }
      }
      this.selectedGroup = this.getFilingGroup(filingID);
      this.filingGroup1 = this.filingGroup.filter((obj: any) => String(obj.LEGAL_ENTITY_ID) !== String((this.selectedGroup || {}).LEGAL_ENTITY_ID));
      this.cdr.detectChanges();
    }
  
    updated1(activityCode: string) {
      this.attribData['8858_NA_PRINCIPAL_ACTIVITY_CODE'] = activityCode;
      if (this.irsF8858ScheduleNAData.length > 0 && this.line1Data) {
        const principal_business_db = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_PRINCIPAL_ACTIVITY_CODE');
        if (principal_business_db) {
          principal_business_db.VALUE == activityCode
            ? this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_PRINCIPAL_ACTIVITY_CODE', 'N')
            : this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_PRINCIPAL_ACTIVITY_CODE', 'Y');
          principal_business_db.VALUE == activityCode
            ? this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_PRINCIPAL_BUSINESS_ACTIVITY', 'N')
            : this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_PRINCIPAL_BUSINESS_ACTIVITY', 'Y');
        }
      }
      this.selectedGroup1 = this.getPrincipalBusinessActivity(activityCode);
      this.attribData['8858_NA_PRINCIPAL_BUSINESS_ACTIVITY'] = (this.selectedGroup1 as any).ACTIVITY_DESC;
      this.cdr.detectChanges();
    }
  
    updated2(activityDesc: string) {
      this.attribData['8858_NA_PRINCIPAL_ACTIVITY_CODE'] = activityDesc;
      if (this.irsF8858ScheduleNAData.length > 0 && this.line1Data) {
        const principal_business_db = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_PRINCIPAL_ACTIVITY_CODE');
        if (principal_business_db) {
          principal_business_db.VALUE == activityDesc
            ? this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_PRINCIPAL_ACTIVITY_CODE', 'N')
            : this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_PRINCIPAL_ACTIVITY_CODE', 'Y');
        }
      }
      this.selectedGroup1 = this.getPrincipalBusinessActivity2(activityDesc);
      this.cdr.detectChanges();
    }
  
    changeCountryLaws(value: string) {
      if (this.line1Data) {
        const country_law = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_ENTITY_COUNTRY_LAWS');
        if (country_law) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_ENTITY_COUNTRY_LAWS', country_law.VALUE === value ? 'N' : 'Y');
      }
      this.cdr.detectChanges();
    }
  
    changeCountry(value: string) {
      if (value === 'US') {
        this.attribData['8858_NA_PERSONS_BOOK_US_COUNTRY'] = 'US';
        this.attribData['8858_NA_PERSONS_BOOK_F_COUNTRY'] = null;
        ['8858_NA_PERSONS_BOOK_F_ADDR_1', '8858_NA_PERSONS_BOOK_F_ADDR_2', '8858_NA_PERSONS_BOOK_F_CITY', '8858_NA_PERSONS_BOOK_F_STATE', '8858_NA_PERSONS_BOOK_F_ZIP'].forEach(k => this.attribData[k] = null);
      } else {
        this.attribData['8858_NA_PERSONS_BOOK_F_COUNTRY'] = value;
        this.attribData['8858_NA_PERSONS_BOOK_US_COUNTRY'] = null;
        ['8858_NA_PERSONS_BOOK_US_ADDR_1', '8858_NA_PERSONS_BOOK_US_ADDR_2', '8858_NA_PERSONS_BOOK_US_CITY', '8858_NA_PERSONS_BOOK_US_STATE', '8858_NA_PERSONS_BOOK_US_ZIP'].forEach(k => this.attribData[k] = null);
      }
      this.cdr.detectChanges();
    }
  
    changePrincipalPlace(value: string) {
      if (this.line1Data) {
        const principal_place = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_COUNTRY_PRINCIPAL_BUSINESS_ACVTY');
        if (principal_place) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_COUNTRY_PRINCIPAL_BUSINESS_ACVTY', principal_place.VALUE === value ? 'N' : 'Y');
      }
      this.cdr.detectChanges();
    }
  
    changeArticle(value: string) {
      this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_TREATY_ARTICLE_NUMBER', 'Y');
      this.cdr.detectChanges();
    }
  
    radioClicked(value: string, value1: any, value2: any) {
      if (value === 'APPLD FOR' || value === 'FOREIGNUS') {
        this.attribData['8858_NA_FDE_FB_EIN'] = null;
        this.refrence_iddisabled = true;
      }
      if (this.line1Data) {
        const ein_reason = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_EIN_MISSING_REASON');
        if (ein_reason) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_EIN_MISSING_REASON', ein_reason.VALUE === value ? 'N' : 'Y');
        const ident_number = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_EIN');
        if (ident_number) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_EIN', ident_number.VALUE === value1 ? 'N' : 'Y');
        const refr_id = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_REFERENCE_ID');
        if (refr_id) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_REFERENCE_ID', refr_id.VALUE === this.attribData['8858_NA_FDE_FB_REFERENCE_ID'] ? 'N' : 'Y');
      }
      this.cdr.detectChanges();
    }
  
    uncheckedRadio(value: any, value1: any, value2: any) {
      if (value != null && value !== '') {
        this.attribData['8858_NA_FDE_FB_EIN_MISSING_REASON'] = null;
        this.attribData['8858_NA_FDE_FB_REFERENCE_ID'] = null;
      }
      if (this.line1Data) {
        const identifying_number = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_EIN');
        if (identifying_number) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_EIN', identifying_number.VALUE === value ? 'N' : 'Y');
        const ein_missing_reason = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_EIN_MISSING_REASON');
        if (ein_missing_reason) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_EIN_MISSING_REASON', ein_missing_reason.VALUE === value1 ? 'N' : 'Y');
        const refrence_id_2 = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_REFERENCE_ID');
        if (refrence_id_2 && (value == null || value === '') && (value2 == null || value2 === '' || value2 === ' ') && refrence_id_2.VALUE !== ' ') {
          this.attribData['8858_NA_FDE_FB_REFERENCE_ID'] = refrence_id_2.VALUE;
        }
        if (refrence_id_2) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_REFERENCE_ID', refrence_id_2.VALUE === this.attribData['8858_NA_FDE_FB_REFERENCE_ID'] ? 'N' : 'Y');
      }
      this.refrence_iddisabled = !(this.attribData['8858_NA_FDE_FB_EIN'] != null && this.attribData['8858_NA_FDE_FB_EIN'] !== '');
      this.cdr.detectChanges();
    }
  
    ref_id(value: any, value1: any, value2: any) {
      if (this.line1Data) {
        const refrence_id = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_REFERENCE_ID');
        if (refrence_id) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_REFERENCE_ID', (refrence_id.VALUE === ' ' ? null : refrence_id.VALUE) === (value === '' ? null : value) ? 'N' : 'Y');
        const ein_missing_reason = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_EIN_MISSING_REASON');
        if (ein_missing_reason) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_EIN_MISSING_REASON', ein_missing_reason.VALUE === this.attribData['8858_NA_FDE_FB_EIN_MISSING_REASON'] ? 'N' : 'Y');
        const identifying_number = this.line1Data.find((x: any) => x.ATTRIB_NAME === 'F8858_NA_FDE_FB_EIN');
        if (identifying_number) this.findIndex_text(this.irsF8858ScheduleNAData, '8858_NA_FDE_FB_EIN', identifying_number.VALUE === value2 ? 'N' : 'Y');
      }
      this.cdr.detectChanges();
    }
  
    personBnssChange() {
      if (this.attribData['8858_NA_2B_FLAG'] === 'N') {
        this.attribData['8858_NA_PERSONS_BOOK_NAME_1'] = null;
        this.attribData['8858_NA_PERSONS_BOOK_NAME_2'] = null;
        this.attribData['8858_NA_PERSONS_BOOK_F_COUNTRY'] = null;
        ['8858_NA_PERSONS_BOOK_F_ADDR_1', '8858_NA_PERSONS_BOOK_F_ADDR_2', '8858_NA_PERSONS_BOOK_F_CITY', '8858_NA_PERSONS_BOOK_F_STATE', '8858_NA_PERSONS_BOOK_F_ZIP',
         '8858_NA_PERSONS_BOOK_US_COUNTRY', '8858_NA_PERSONS_BOOK_US_ADDR_1', '8858_NA_PERSONS_BOOK_US_ADDR_2', '8858_NA_PERSONS_BOOK_US_CITY', '8858_NA_PERSONS_BOOK_US_STATE', '8858_NA_PERSONS_BOOK_US_ZIP'].forEach(k => this.attribData[k] = null);
        this.countryCust = '';
      }
      if (this.attribData['8858_NA_2B_FLAG'] === 'P') this.attribData['8858_NA_PERSONS_BOOK_NAME_2'] = null;
      this.cdr.detectChanges();
    }
  
    clicked_a() {
      if (this.attribData['8858_NA_US_AGENT_EIN_MISSING_REASON'] === 'APPLD FOR' || this.attribData['8858_NA_US_AGENT_EIN_MISSING_REASON'] === 'FOREIGNUS') {
        this.attribData['8858_NA_US_AGENT_EIN'] = null;
      }
      this.cdr.detectChanges();
    }
  
    unchecked_a() {
      if (this.attribData['8858_NA_US_AGENT_EIN'] != null) {
        this.attribData['8858_NA_US_AGENT_EIN_MISSING_REASON'] = null;
      }
      this.cdr.detectChanges();
    }
  
    onRadioBtnSelection(row: any, index: number, value: string) {
      if (Array.isArray(row.value)) {
        if (value === 'Y') {
          row.value[0].VALUE = 'Y';
          row.value[1].VALUE = null;
        } else {
          row.value[0].VALUE = null;
          row.value[1].VALUE = 'N';
        }
      }
      this.cdr.detectChanges();
    }
  
    /** Display value with commas for Schedule G/I value inputs. */
    formatValueForDisplay(row: any): string {
      const val = row?.value?.VALUE;
      if (val == null || val === '') return '';
      return this.numberWithCommasPipe.transform(val) ?? '';
    }
  
    /** Restrict keypress to numbers only (for amount fields). */
    onNumberKeyPress(event: KeyboardEvent): boolean {
      const charCode = event.which ? event.which : event.keyCode;
      // Allow: digits (0-9), minus sign (-), backspace, tab, delete, arrows
      if (charCode === 45) return true; // minus sign for negative numbers
      if (charCode >= 48 && charCode <= 57) return true; // digits 0-9
      if (charCode === 8 || charCode === 9 || charCode === 46) return true; // backspace, tab, delete
      if (charCode >= 37 && charCode <= 40) return true; // arrow keys
      event.preventDefault();
      return false;
    }
  
    /** Strip non-numeric characters (except minus sign) and set raw value for Schedule G. */
    onValueChangeG(row: any, displayStr: string, index: number): void {
      if (!row?.value) return;
      // Remove commas and any non-numeric characters (except minus sign)
      let raw = typeof displayStr === 'string' ? displayStr.replace(/,/g, '').replace(/[^0-9\-]/g, '') : displayStr;
      row.value.VALUE = raw;
      this.checkingForValidation(row, index);
    }
  
    /** Strip non-numeric characters (except minus sign) and set raw value for Schedule I. */
    onValueChangeI(row: any, displayStr: string, index: number): void {
      if (!row?.value) return;
      // Remove commas and any non-numeric characters (except minus sign)
      let raw = typeof displayStr === 'string' ? displayStr.replace(/,/g, '').replace(/[^0-9\-]/g, '') : displayStr;
      row.value.VALUE = raw;
      this.checkingForValidationForI(row, index);
    }
  
    checkingForValidation(row: any, index: number) {
      if (!row || !row.propertyType) {
        this.cdr.detectChanges();
        return;
      }
  
      const colType = row.propertyType == 13 ? 'radio' : (row.propertyType == 7 ? 'amount' : '');
      let occList: any[] = [];
  
      if (colType === 'radio') {
        occList = this.scheduleGData.filter((o: any) => o.parent_line_no === row.line_no);
      } else if (colType === 'amount') {
        occList = this.scheduleGData.filter((o: any) => o.line_no === row.line_no);
      }
  
      occList.forEach((currentObj: any) => {
        if (!currentObj) return;
        if (currentObj.line_no === currentObj.parent_line_no && 
            currentObj.col_id === currentObj.parent_col_id && 
            currentObj.line_type !== 'dcl') {
          return;
        }
        const attribute = currentObj.attrib_name;
        const col_id = currentObj.col_id;
        const parent_col_id = currentObj.parent_col_id;
  
        if (colType === 'radio' && row.line_type !== 'dcl') {
          // Safe check for row.value array
          if (Array.isArray(row.value) && row.value[1]?.VALUE === 'N' && col_id === parent_col_id) {
            this.findIndex_1(attribute, 'N', 'Y');
          } else if (Array.isArray(row.value) && row.value[0]?.VALUE === 'Y' && col_id === parent_col_id) {
            this.findIndex_1(attribute, 'Y', 'N');
          }
        }
  
        if (colType === 'amount' && row.line_type !== 'dcl') {
          const validLine_no = currentObj.parent_line_no;
          const findLineNoData = this.scheduleGData.find((x: any) => x.line_no === validLine_no);
          if (findLineNoData && Array.isArray(findLineNoData.value)) {
            if ((findLineNoData.value[0]?.VALUE == null && findLineNoData.value[1]?.VALUE == null)) {
              this.findIndex_1(attribute, 'Y', 'Y');
            }
            if (findLineNoData.value[1]?.VALUE != null) {
              this.findIndex_1(attribute, 'N', 'Y');
            }
            if (findLineNoData.value[0]?.VALUE != null) {
              this.findIndex_1(attribute, 'Y', 'Y');
            }
          }
        }
  
        if (row.line_type === 'dcl') {
          this.findIndex_1(attribute, 'N', 'Y');
        }
      });
  
      this.cdr.detectChanges();
    }
  
    private findIndex_1(attribName: string, value: string, saveFlag: string) {
      const findData = this.scheduleGData.find((x: any) => x.attrib_name === attribName);
      if (!findData) return;
  
      if ((findData.col_id === findData.parent_col_id) && (findData.line_type !== 'dcl')) {
        if (findData.value?.VALUE != null) {
          findData.isEditableFlag = value;
          findData.isSaveValidFlagG = 'Y';
        } else {
          findData.isEditableFlag = value;
          findData.isSaveValidFlagG = saveFlag;
        }
        if (value === 'N') {
          findData.isEditableFlag = 'N';
          if (findData.value && !Array.isArray(findData.value)) {
            findData.value.VALUE = null;
          }
          findData.isSaveValidFlagG = 'Y';
          if (Array.isArray(findData.value) && findData.value[1]?.VALUE != null) {
            findData.value[0].VALUE = null;
          }
        }
        if (Array.isArray(findData.value) && findData.value[0]?.VALUE != null) {
          findData.value[1].VALUE = null;
        }
      }
      if (findData.line_type === 'dcl') {
        findData.isEditableFlag = 'N';
        findData.isSaveValidFlagG = 'Y';
      }
    }
  
    checkingForValidationForI(row: any, index: number) {
      if (!row || !Array.isArray(row.value)) {
        this.cdr.detectChanges();
        return;
      }
  
      // Line 1 validation
      if (row.line_no === '1') {
        if (row.value[1]?.VALUE === 'N') {
          if (this.scheduleIData[1]) {
            this.scheduleIData[1].isEditableFlag = 'N';
            if (Array.isArray(this.scheduleIData[1].value)) {
              this.scheduleIData[1].value[0].VALUE = null;
              this.scheduleIData[1].value[1].VALUE = null;
            }
          }
          if (this.scheduleIData[2]) {
            this.scheduleIData[2].isEditableFlag = 'N';
            if (Array.isArray(this.scheduleIData[2].value)) {
              this.scheduleIData[2].value[0].VALUE = null;
              this.scheduleIData[2].value[1].VALUE = null;
            }
          }
          if (this.scheduleIData[3]) {
            this.scheduleIData[3].isEditableFlag = 'N';
            if (this.scheduleIData[3].value && !Array.isArray(this.scheduleIData[3].value)) {
              this.scheduleIData[3].value.VALUE = null;
            }
          }
        } else if (row.value[0]?.VALUE === 'Y') {
          if (this.scheduleIData[1]) this.scheduleIData[1].isEditableFlag = 'Y';
          if (this.scheduleIData[2]) this.scheduleIData[2].isEditableFlag = 'Y';
          if (this.scheduleIData[3]) this.scheduleIData[3].isEditableFlag = 'Y';
        }
      }
  
      // Line 2 validation
      if (row.line_no === '2') {
        if (row.value[1]?.VALUE === 'N') {
          if (this.scheduleIData[2]) {
            this.scheduleIData[2].isEditableFlag = 'N';
            if (Array.isArray(this.scheduleIData[2].value)) {
              this.scheduleIData[2].value[0].VALUE = null;
              this.scheduleIData[2].value[1].VALUE = null;
            }
          }
          if (this.scheduleIData[3]) {
            this.scheduleIData[3].isEditableFlag = 'N';
            if (this.scheduleIData[3].value && !Array.isArray(this.scheduleIData[3].value)) {
              this.scheduleIData[3].value.VALUE = null;
            }
          }
        } else if (row.value[0]?.VALUE === 'Y') {
          if (this.scheduleIData[2]) this.scheduleIData[2].isEditableFlag = 'Y';
          if (this.scheduleIData[3]) this.scheduleIData[3].isEditableFlag = 'Y';
        }
      }
  
      // Line 3 validation
      if (row.line_no === '3') {
        const data0 = this.scheduleIData[0];
        const data1 = this.scheduleIData[1];
        if (row.value[1]?.VALUE === 'N' || 
            (data0?.value && !Array.isArray(data0.value) && data0.value.VALUE === 'N') || 
            (data1?.value && !Array.isArray(data1.value) && data1.value.VALUE === 'N')) {
          if (this.scheduleIData[3]) {
            this.scheduleIData[3].isEditableFlag = 'N';
            if (this.scheduleIData[3].value && !Array.isArray(this.scheduleIData[3].value)) {
              this.scheduleIData[3].value.VALUE = null;
            }
          }
        } else if (row.value[0]?.VALUE === 'Y') {
          if (this.scheduleIData[3]) this.scheduleIData[3].isEditableFlag = 'Y';
        }
      }
  
      this.cdr.detectChanges();
    }
  
    checkingForValidSave(scope: any[], scheduleType: string) {
      if (scheduleType === 'G') {
        this.isSaveValidFlagG = !scope.some((r: any) => r.isSaveValidFlagG === 'N');
        if (!this.isSaveValidFlagG) this.invalidSaveMessageG = 'Please check the below errors';
      } else {
        this.isSaveValidFlagI = !scope.some((r: any) => r.isSaveValidFlagI === 'N');
        if (!this.isSaveValidFlagI) this.invalidSaveMessageI = 'Please check the below errors';
      }
    }
  
    openCalendar() {
      this.calendar.opened = true;
      this.cdr.detectChanges();
    }
  
    // Prepares the Schedule NA payload and returns the cold save observable (or null
    // if EIN validation fails). The caller (saveScheduleGData) subscribes and chains
    // the Schedule G save sequentially so the two saves never race on the backend.
    private prepareNASave(): Observable<any> | null {
      const editRow: any[] = [];
      const scheduleSettings = [{
        tax_year: this.getTaxYear(),
        scenario: this.getScenario(),
        jcd_key: this.getJcdKey()
      }];
  
      const ein = this.attribData['8858_NA_FDE_FB_EIN'];
      const einReason = this.attribData['8858_NA_FDE_FB_EIN_MISSING_REASON'];
      const refId = this.attribData['8858_NA_FDE_FB_REFERENCE_ID'];
      if ((ein == null || ein === '') && (einReason == null || einReason === '') && (refId == null || refId === '' || refId === ' ')) {
        this.error_flag = true;
        this.gtwSnackbarService.openSnackBar('Please enter Identifying number or EIN missing reason Or Reference ID number', 'gtw-snackbar--red');
        return null;
      }
      this.error_flag = false;
  
      const fmt = (d: any) => (d instanceof Date ? d.toISOString().slice(0, 10) : d);
      if (this.attribData['8858_NA_FDE_BEGIN_DATE']) this.attribData['8858_NA_FDE_BEGIN_DATE'] = fmt(this.attribData['8858_NA_FDE_BEGIN_DATE']);
      if (this.attribData['8858_NA_FDE_END_DATE']) this.attribData['8858_NA_FDE_END_DATE'] = fmt(this.attribData['8858_NA_FDE_END_DATE']);
      if (this.attribData['8858_NA_ENTITY_ORGANIZATION_DATE']) this.attribData['8858_NA_ENTITY_ORGANIZATION_DATE'] = fmt(this.attribData['8858_NA_ENTITY_ORGANIZATION_DATE']);
      if (this.attribData['8858_NA_FDE_EFFECTIVE_DATE']) this.attribData['8858_NA_FDE_EFFECTIVE_DATE'] = fmt(this.attribData['8858_NA_FDE_EFFECTIVE_DATE']);
      if (this.attribData['8858_NA_FILER_BEGIN_DATE']) this.attribData['8858_NA_FILER_BEGIN_DATE'] = fmt(this.attribData['8858_NA_FILER_BEGIN_DATE']);
      if (this.attribData['8858_NA_FILER_END_DATE']) this.attribData['8858_NA_FILER_END_DATE'] = fmt(this.attribData['8858_NA_FILER_END_DATE']);
  
      if (this.countryVar === 'US') {
        this.attribData['8858_NA_FDE_FB_US_COUNTRY'] = this.countryVar;
        this.attribData['8858_NA_FDE_FB_F_COUNTRY'] = null;
        ['8858_NA_FDE_FB_F_ADDR_1', '8858_NA_FDE_FB_F_ADDR_2', '8858_NA_FDE_FB_F_CITY', '8858_NA_FDE_FB_F_STATE', '8858_NA_FDE_FB_F_ZIP'].forEach(k => this.attribData[k] = null);
      } else {
        this.attribData['8858_NA_FDE_FB_F_COUNTRY'] = this.countryVar;
        this.attribData['8858_NA_FDE_FB_US_COUNTRY'] = null;
        ['8858_NA_FDE_FB_US_ADDR_1', '8858_NA_FDE_FB_US_ADDR_2', '8858_NA_FDE_FB_US_CITY', '8858_NA_FDE_FB_US_STATE', '8858_NA_FDE_FB_US_ZIP'].forEach(k => this.attribData[k] = null);
      }
      if (this.countryCust === 'US') {
        this.attribData['8858_NA_PERSONS_BOOK_US_COUNTRY'] = this.countryCust;
        this.attribData['8858_NA_PERSONS_BOOK_F_COUNTRY'] = null;
        ['8858_NA_PERSONS_BOOK_F_ADDR_1', '8858_NA_PERSONS_BOOK_F_ADDR_2', '8858_NA_PERSONS_BOOK_F_CITY', '8858_NA_PERSONS_BOOK_F_STATE', '8858_NA_PERSONS_BOOK_F_ZIP'].forEach(k => this.attribData[k] = null);
      } else {
        this.attribData['8858_NA_PERSONS_BOOK_F_COUNTRY'] = this.countryCust;
        this.attribData['8858_NA_PERSONS_BOOK_US_COUNTRY'] = null;
        ['8858_NA_PERSONS_BOOK_US_ADDR_1', '8858_NA_PERSONS_BOOK_US_ADDR_2', '8858_NA_PERSONS_BOOK_US_CITY', '8858_NA_PERSONS_BOOK_US_STATE', '8858_NA_PERSONS_BOOK_US_ZIP'].forEach(k => this.attribData[k] = null);
      }
      const regCountry = this.selectedGroup && (this.selectedGroup as any).REG_ADDRESS_COUNTRY;
      if (this.selectedGroup && regCountry === 'US') {
        this.attribData['8858_NA_FILER_US_ADDR_1'] = (this.selectedGroup as any).FILER_ADDR_LINE1;
        this.attribData['8858_NA_FILER_US_ADDR_2'] = (this.selectedGroup as any).FILER_ADDR_LINE2;
        this.attribData['8858_NA_FILER_US_CITY'] = (this.selectedGroup as any).REG_ADDRESS_CITY;
        this.attribData['8858_NA_FILER_US_STATE'] = (this.selectedGroup as any).REG_ADDRESS_STATE;
        this.attribData['8858_NA_FILER_US_COUNTRY'] = (this.selectedGroup as any).REG_ADDRESS_COUNTRY;
        this.attribData['8858_NA_FILER_US_ZIP'] = (this.selectedGroup as any).REG_ADDRESS_ZIP;
        this.attribData['8858_NA_FILER_BEGIN_DATE'] = this.formatDateForInput((this.selectedGroup as any).FILER_TAX_YEAR_BEGIN);
        this.attribData['8858_NA_FILER_END_DATE'] = this.formatDateForInput((this.selectedGroup as any).FILER_TAX_YEAR_END);
        this.attribData['8858_NA_FILER_NAME_1'] = (this.selectedGroup as any).LEGAL_ENTITY_NAME;
        this.attribData['8858_NA_FILER_LEGAL_ENTITY_ID'] = (this.selectedGroup as any).LEGAL_ENTITY_ID;
        this.attribData['8858_NA_FILER_EIN'] = (this.selectedGroup as any).FILER_EIN;
        ['8858_NA_FILER_F_ADDR_1', '8858_NA_FILER_F_ADDR_2', '8858_NA_FILER_F_CITY', '8858_NA_FILER_F_STATE', '8858_NA_FILER_F_COUNTRY', '8858_NA_FILER_F_ZIP'].forEach(k => this.attribData[k] = null);
      } else if (this.selectedGroup && Object.keys(this.selectedGroup).length > 0 && regCountry != null && regCountry !== '' && regCountry !== 'US') {
        const sg = this.selectedGroup as any;
        this.attribData['8858_NA_FILER_F_ADDR_1'] = sg.FILER_ADDR_LINE1;
        this.attribData['8858_NA_FILER_F_ADDR_2'] = sg.FILER_ADDR_LINE2;
        this.attribData['8858_NA_FILER_F_CITY'] = sg.REG_ADDRESS_CITY;
        this.attribData['8858_NA_FILER_F_STATE'] = sg.REG_ADDRESS_STATE;
        this.attribData['8858_NA_FILER_F_COUNTRY'] = sg.REG_ADDRESS_COUNTRY;
        this.attribData['8858_NA_FILER_F_ZIP'] = sg.REG_ADDRESS_ZIP;
        this.attribData['8858_NA_FILER_BEGIN_DATE'] = this.formatDateForInput(sg.FILER_TAX_YEAR_BEGIN);
        this.attribData['8858_NA_FILER_END_DATE'] = this.formatDateForInput(sg.FILER_TAX_YEAR_END);
        this.attribData['8858_NA_FILER_NAME_1'] = sg.LEGAL_ENTITY_NAME;
        this.attribData['8858_NA_FILER_LEGAL_ENTITY_ID'] = sg.LEGAL_ENTITY_ID;
        this.attribData['8858_NA_FILER_EIN'] = sg.FILER_EIN;
        ['8858_NA_FILER_US_ADDR_1', '8858_NA_FILER_US_ADDR_2', '8858_NA_FILER_US_CITY', '8858_NA_FILER_US_STATE', '8858_NA_FILER_US_COUNTRY', '8858_NA_FILER_US_ZIP'].forEach(k => this.attribData[k] = null);
      } else if (this.selectedGroup && Object.keys(this.selectedGroup).length > 0) {
        this.attribData['8858_NA_FILER_BEGIN_DATE'] = this.formatDateForInput((this.selectedGroup as any).FILER_TAX_YEAR_BEGIN);
        this.attribData['8858_NA_FILER_END_DATE'] = this.formatDateForInput((this.selectedGroup as any).FILER_TAX_YEAR_END);
        this.attribData['8858_NA_FILER_NAME_1'] = (this.selectedGroup as any).LEGAL_ENTITY_NAME;
        this.attribData['8858_NA_FILER_LEGAL_ENTITY_ID'] = (this.selectedGroup as any).LEGAL_ENTITY_ID;
        this.attribData['8858_NA_FILER_EIN'] = (this.selectedGroup as any).FILER_EIN;
      }
      if (this.radioIn === 'I') {
        this.attribData['8858_NA_INIT_FORM_Y'] = '1';
        this.attribData['8858_NA_INIT_FORM_N'] = null;
        this.attribData['8858_NA_FINAL_FORM_Y'] = null;
        this.attribData['8858_NA_FINAL_FORM_N'] = '0';
      } else if (this.radioIn === 'F') {
        this.attribData['8858_NA_FINAL_FORM_Y'] = '1';
        this.attribData['8858_NA_FINAL_FORM_N'] = null;
        this.attribData['8858_NA_INIT_FORM_N'] = '0';
        this.attribData['8858_NA_INIT_FORM_Y'] = null;
      } else if (this.radioIn === 'N') {
        this.attribData['8858_NA_FINAL_FORM_Y'] = null;
        this.attribData['8858_NA_FINAL_FORM_N'] = null;
        this.attribData['8858_NA_INIT_FORM_N'] = null;
        this.attribData['8858_NA_INIT_FORM_Y'] = null;
      }
      if (this.selectedGroup1 && (this.selectedGroup1 as any).ACTIVITY_DESC) {
        this.attribData['8858_NA_PRINCIPAL_BUSINESS_ACTIVITY'] = (this.selectedGroup1 as any).ACTIVITY_DESC;
      }
  
      const temporaryObject = this.irsF8858ScheduleNAData;
      for (let loopIndex = 0; loopIndex < temporaryObject.length; loopIndex++) {
        const t = temporaryObject[loopIndex] as any;
        if (!t || t.attrib_name == null || t.attrib_name === '') continue;
        const attrVal = this.attribData[t.attrib_name];
        editRow.push([{
          tax_year: this.getTaxYear(),
          trans_type_key: t.trans_type_key,
          combination_key: this.rowData.COMBINATION_KEY,
          group_obj_key: this.rowData.GROUP_OBJ_KEY,
          form_key: t.form_key,
          line_no: t.i?.line_no ?? t.line_no,
          occurence: (t.occurrence === '0' ? null : t.occurrence),
          line_attrib_key: t.line_attrib_key,
          Attribute_Name: t.attrib_name,
          Attribute_Value: (attrVal === undefined || attrVal === null ? '' : (attrVal === '' ? '' : attrVal)),
          trans_dtls_key: (t.trans_details_key === '0' ? null : t.trans_details_key),
          trans_status: 'A',
          override_y_n: (t.is_update === undefined ? 'N' : t.is_update)
        }]);
      }
  
      const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };
      const enrichedGS = this.buildSaveGlobalService();
      return this.service.saveScheduleNA(this.GENERAL_CONFIG.base_url, scheduleSettings, scheduleDetails, enrichedGS, this.filterParams, this.rowData);
    }

    saveScheduleGData() {
      if (this.crudLoading) {
        this.gtwSnackbarService.openSnackBar('Please wait while we save this request', 'gtw-snackbar--yellow');
        return;
      }
      // Build the Schedule NA save first; null means EIN validation failed (snackbar
      // already shown). We do NOT fire it yet — it is chained after validation below.
      const naObs = this.prepareNASave();
      if (naObs === null) {
        return;
      }
      this.crudLoading = true;
      this.cdr.detectChanges();
  
      // Match AngularJS: jsonSettings is [{ tax_year, scenario, jcd_key }]; jcd_key from globalParams only, default 250
      const jcdKey = this.globalService?.jcd_key;
      const scheduleSettings = [{
        tax_year: this.getTaxYear(),
        scenario: this.getScenario(),
        jcd_key: (jcdKey === '' || jcdKey === undefined) ? 250 : (jcdKey ?? 250)
      }];
      const editRow: any[] = [];
      const taxYear = this.getTaxYear();

      // Matches AngularJS behaviour for JSON.stringify:
      //  - line_attrib_key / Attribute_Value: when undefined, JSON.stringify omits
      //    the key entirely (backend accepts absent fields but rejects empty strings).
      //  - When null or a string, JSON.stringify includes the value normally.
      const buildRow = (sp: any, lineNo: string, val: any, attribName: string) => {
        // Prefer the attribute's own keys (captured in processScheduleGOrI); fall back
        // to the line marker. On first save these are '0' → null → INSERT; on re-save
        // the real keys are present → UPDATE.
        const transDtls =
          (val?.trans_dtls_key != null && val.trans_dtls_key !== '0')
            ? val.trans_dtls_key
            : (sp?.trans_Details_key === '0' ? null : sp?.trans_Details_key);
        const occ =
          (val?.occurrence != null && val.occurrence !== '0')
            ? val.occurrence
            : (sp?.occurrence === '0' ? null : sp?.occurrence);
        return {
          tax_year: taxYear,
          trans_type_key: sp?.trans_type_key,
          combination_key: this.rowData.COMBINATION_KEY,
          group_obj_key: this.rowData.GROUP_OBJ_KEY,
          form_key: sp?.form_key,
          line_no: lineNo,
          occurence: occ,
          line_attrib_key: val?.line_attrib_key,
          Attribute_Name: attribName,
          Attribute_Value: val?.VALUE,
          trans_dtls_key: transDtls,
          trans_status: 'A'
        };
      };

      const processRows = (data: any[]) => {
        for (let i = 0; i < data.length; i++) {
          const row = data[i];
          if (row.hasOwnProperty('propertyType') && String(row.propertyType) === '13'
              && Array.isArray(row.attrib_name) && Array.isArray(row.value)) {
            // Normalize radio pair: if ANY side has a VALUE, ensure all sides
            // have an explicit VALUE (null for unset). This mirrors the result
            // of setAmt() / onRadioBtnSelection which always set both sides,
            // guarding against the async setAmt() not completing before save.
            const hasAnyValue = row.value.some((v: any) => v?.VALUE !== undefined);
            if (hasAnyValue) {
              for (let k = 0; k < row.value.length; k++) {
                if (row.value[k] && row.value[k].VALUE === undefined) {
                  row.value[k].VALUE = null;
                }
              }
            }
            for (let k = 0; k < row.attrib_name.length; k++) {
              editRow.push([buildRow(row.saveParams, row.line_no, row.value[k], row.attrib_name[k])]);
            }
          } else {
            editRow.push([buildRow(row.saveParams, row.line_no, row.value, row.attrib_name)]);
          }
        }
      };

      processRows(this.scheduleGData);
      processRows(this.scheduleIData);
  
      this.checkingForValidSave(this.scheduleGData, 'G');
      this.checkingForValidSave(this.scheduleIData, 'I');
      if (this.isSaveValidFlagG && this.isSaveValidFlagI) {
        const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };
        const enrichedGS = this.buildSaveGlobalService();
        // Serialize: Schedule NA save first, then Schedule G/I save, then a single
        // reload — so the two saves never hit PROC_FIR_FORM_SAVE concurrently and the
        // reload reflects committed data (no stale-data flash before the modal closes).
        naObs.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
          next: (naResult: any) => {
            if (naResult?.errorMessage && naResult.errorMessage !== 'null') {
              this.crudLoading = false;
              this.gtwSnackbarService.openSnackBar(naResult.errorMessage, 'gtw-snackbar--red');
              this.cdr.detectChanges();
              return;
            }
            this.service.saveScheduleG(this.GENERAL_CONFIG.base_url, scheduleSettings, scheduleDetails, enrichedGS, this.filterParams, this.rowData).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
              next: (result: any) => {
                this.crudLoading = false;
                if (result?.errorMessage && result.errorMessage !== 'null') {
                  this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
                } else {
                  this.saveFlag = true;
                  this.gtwSnackbarService.openSnackBar('Schedule G and I details are successfully save/edit', 'gtw-snackbar--green');
                  this.getFormData();
                  this.requestGridUpdate.emit('refresh');
                }
                this.cdr.detectChanges();
              },
              error: () => {
                this.crudLoading = false;
                this.gtwSnackbarService.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red');
                this.cdr.detectChanges();
              }
            });
          },
          error: () => {
            this.crudLoading = false;
            this.gtwSnackbarService.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red');
            this.cdr.detectChanges();
          }
        });
      } else {
        this.crudLoading = false;
        let msg = '';
        if (!this.isSaveValidFlagG && !this.isSaveValidFlagI) msg = (this.invalidSaveMessageG || '') + '\n' + (this.invalidSaveMessageI || '');
        else if (!this.isSaveValidFlagG) msg = this.invalidSaveMessageG || '';
        else msg = this.invalidSaveMessageI || '';
        this.gtwSnackbarService.openSnackBar(msg || 'Please check errors', 'gtw-snackbar--red');
        this.cdr.detectChanges();
      }
    }
  
    reset() {
      this.crudLoading = false;
      this.resetAndInit();
      this.cdr.detectChanges();
    }
  
    cancel() {
      this.requestGridUpdate.emit('cancel');
    }
  
    /** Update attribData date and trigger change detection so date picker stays interactive */
    onDateChange(attribKey: string, value: Date | string | null): void {
      this.attribData[attribKey] = value;
      this.cdr.detectChanges();
    }
  }
  